"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.electionsSchema = void 0;
const zod_1 = require("zod");
const election_schema_1 = require("./election.schema");
exports.electionsSchema = zod_1.z.array(election_schema_1.electionSchema).describe("List of elections");
